export const TRANSPORT_PERFORMANCE_GROUPS_KEY = 'transport_performance_groups';

export type TTransportPerformanceGroups = Record<string, number[]>;

export const getGroups = (): TTransportPerformanceGroups => {
  try {
    const raw = localStorage.getItem(TRANSPORT_PERFORMANCE_GROUPS_KEY);

    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw);

    return parsed as TTransportPerformanceGroups;
  } catch {
    return {};
  }
};

const persistGroups = (groups: TTransportPerformanceGroups): void => {
  localStorage.setItem(TRANSPORT_PERFORMANCE_GROUPS_KEY, JSON.stringify(groups));
};

export const saveGroup = (name: string, transportIds: number[]): TTransportPerformanceGroups => {
  const groups = { ...getGroups(), [name]: transportIds };
  persistGroups(groups);
  return groups;
};

export const deleteGroup = (name: string): TTransportPerformanceGroups => {
  const groups = getGroups();
  delete groups[name];
  persistGroups(groups);
  return groups;
};
